// extracted by mini-css-extract-plugin
export default {"login":"Login_login__-wPqN","loginButton":"Login_loginButton__ux34q","icon":"Login_icon__NT+53"};